document.addEventListener('DOMContentLoaded', () => {
	if (typeof gsap === 'undefined') return;

	const OFFSET_X = 20;
	const OFFSET_Y = 20;

	const BREAKPOINT = 768; // px

	// Wrapper that MOVES
	const wrap = document.createElement('div');
	wrap.id = 'restaurant-preview-wrap';
	wrap.setAttribute('aria-hidden', 'true'); // decorative UI
	wrap.setAttribute('role', 'presentation'); // not content

	// Image that SCALES
	const img = document.createElement('img');
	img.id = 'restaurant-preview';
	img.alt = ''; // decorative image => empty alt
	img.decoding = 'async';
	img.loading = 'eager'; // it's used immediately on hover
	img.setAttribute('aria-hidden', 'true');
	img.setAttribute('role', 'presentation');

	// prevent it from being tabbable/focusable
	img.tabIndex = -1;

	wrap.appendChild(img);
	document.body.appendChild(wrap);

	// Start hidden via scale (on the IMG only)
	gsap.set(img, { scale: 0 });
	// Start wrapper at 0,0
	gsap.set(wrap, { x: 0, y: 0 });

	// Smooth follow on the WRAPPER only
	const moveX = gsap.quickTo(wrap, 'x', {
		duration: 0.2,
		ease: 'power3.out',
	});
	const moveY = gsap.quickTo(wrap, 'y', {
		duration: 0.2,
		ease: 'power3.out',
	});

	function move(e) {
		moveX(e.clientX + OFFSET_X);
		moveY(e.clientY + OFFSET_Y);
	}

	function show() {
		gsap.to(img, {
			scale: 1,
			duration: 0.25,
			ease: 'power3.out',
			overwrite: 'auto',
		});
	}

	function hide() {
		gsap.to(img, {
			scale: 0,
			duration: 0.2,
			ease: 'power3.in',
			overwrite: 'auto',
		});
	}

	if (window.innerWidth < BREAKPOINT) return; // Don't activate on small screens

	document
		.querySelectorAll('.wp-block-cancan-interactive-restaurants')
		.forEach((block) => {
			block.querySelectorAll('.restaurant-card').forEach((card) => {
				const src = card.getAttribute('data-preview');
				if (!src) return;

				card.addEventListener('mouseenter', (e) => {
					img.src = src;
					move(e);
					show();
				});

				card.addEventListener('mouseleave', hide);
			});
			block.addEventListener('mousemove', move);
		});
});
